import { Component } from 'react'
import { HIDE_SIDEBAR_POPUP_MOUSE_LEFT_TIMEOUT } from 'constants/component'
import * as debounce from 'lodash/debounce'

export type SidebarPopupBaseProps = {
  className: string
  hidePopupTimeoutId: number | null
  onRegisterHideTimeout: (timeoutId: number) => void
  onHidePopup: () => void
}

export class SidebarPopupBase extends Component<SidebarPopupBaseProps> {
  render () {
    const {
      className,
      children,
    } = this.props

    return (
      <section
        className={ className }
        onMouseEnter={ this.handleMouseEnter }
        onMouseLeave={ this.handleMouseLeave }
      >
        { children }
      </section>
    )
  }

  componentWillUnmount () {
    this.handleMouseEnter.cancel()
  }

  // debounce because sometimes mouse enter is called before mouse leave
  private handleMouseEnter = debounce(() => {
    const { hidePopupTimeoutId } = this.props
    if (typeof hidePopupTimeoutId === 'number') {
      clearTimeout(hidePopupTimeoutId)
    }
  }, 20)

  private handleMouseLeave = () => {
    const { onRegisterHideTimeout, onHidePopup } = this.props
    const timeoutId = window.setTimeout(onHidePopup, HIDE_SIDEBAR_POPUP_MOUSE_LEFT_TIMEOUT)
    onRegisterHideTimeout(timeoutId)
  }
}
